import { AgentNetConfirmationDialog } from './ConfirmationDialog';

interface UnsavedChangesDialogProps {
  open: boolean;
  saving: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onStay: () => void;
}

const UnsavedChangesDialog = ({ open, saving, onSave, onDiscard, onStay }: UnsavedChangesDialogProps) => (
  <AgentNetConfirmationDialog
    open={open}
    onConfirm={onSave}
    onDismissAction={onDiscard}
    onExitButtonAction={onStay}
    disabled={saving}
    disableCrossIconClick={saving}
    dialogTitle="Save Confirmation"
    dialogBtnContent="Save"
    secondaryActionBtnContent="Don't Save"
    dialogText="You have made changes to information on this page. Do you want to save the changes before you proceed?"
    disableBackDropClick
    qaAttrPrefix="ConfirmationSave"
  />
);

export default UnsavedChangesDialog;
